const TYPES = ['USER_D', 'USER_M', 'CONVENTION', 'FAMILY', 'VOLUME'];
const STATUS = ['ACTIVE', 'PENDING', 'CLOSED'];
const LEVELS = ['LEVEL_1', 'LEVEL_2', 'LEVEL_3'];

const CLIENT_NAMES = [
  'Atlas Banking Group', 'NovaCare Insurance', 'Helix Retail SAS',
  'Beacon Logistics International', 'Polaris Energy Holdings',
  'TerraTel Networks', 'Quantum Health Systems', 'OrionPay Financial',
];

const NOTES = [
  'Repeated login failures from new geography.',
  'Privileged account used outside business hours.',
  'Convention family approaching saturation (>92%).',
  'Volume of access requests above 30-day moving average.',
  'Service account credential not rotated in 180 days.',
  'Anomalous access pattern flagged by behavioural model.',
  'Manual review requested by KAM during quarterly audit.',
  'Account holder leaving the organisation in 14 days.',
];

const rng = (seed) => {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
};

const pick = (arr, r) => arr[Math.floor(r() * arr.length)];
const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

const r = rng(23);
export const ALL_ALERTS = Array.from({ length: 60 }, (_, i) => {
  const status = pick(STATUS, r);
  const createdAgo = Math.floor(r() * 90) + 1;
  return {
    id: `alr-${String(i + 1).padStart(4, '0')}`,
    type: pick(TYPES, r),
    status,
    level: pick(LEVELS, r),
    clientName: pick(CLIENT_NAMES, r),
    clientId: `cli-${String(Math.floor(r() * 25) + 1).padStart(4, '0')}`,
    userId: `user${Math.floor(r() * 9999)}`,
    userFirstName: ['Camille', 'Hugo', 'Léa', 'Sven', 'Amara'][Math.floor(r() * 5)],
    userLastName: ['Durand', 'Schmidt', 'Almeida', 'O\'Connor', 'Ben Salem'][Math.floor(r() * 5)],
    note: pick(NOTES, r),
    // Le composant AlertsTable utilise createdDate / closedDate (avec 'd')
    createdDate: daysAgo(createdAgo),
    closedDate: status === 'CLOSED' ? daysAgo(Math.max(0, createdAgo - Math.floor(r() * createdAgo))) : null,
    updateDate: daysAgo(Math.floor(r() * Math.max(1, createdAgo))),
  };
});

export const filterAlerts = ({ type = '', status = '' }) => {
  return ALL_ALERTS.filter((a) => {
    if (type && a.type !== type) return false;
    if (status && a.status !== status) return false;
    return true;
  });
};

export const computeAlertStatusStats = () => {
  const map = {};
  ALL_ALERTS.forEach((a) => { map[a.status] = (map[a.status] || 0) + 1; });
  return Object.entries(map).map(([status, count]) => ({ status, count }));
};
